import { BaseService } from '../../infra/base.service'
import type { Audience } from './audience'
import type { PreviewOrGenerateAudienceDto } from './dto/audience-preview-generate.dto'
import type { AudiencesRepository } from './audiences.repository'
import type { CreateStaticAudienceDto } from './dto/create-static-audience.dto'

export class AudiencesService extends BaseService<Audience> {
    constructor(private rep: AudiencesRepository) {
        super(rep)
    }

    async getPreview(dto: PreviewOrGenerateAudienceDto) {
        return await this.rep.getPreview(dto)
    }

    async generateAudience(audienceId: string) {
        return await this.rep.generateAudience(audienceId)
    }

    async createStaticAudience(createStaticAudienceDto: CreateStaticAudienceDto) {
        return await this.rep.createStaticAudience(createStaticAudienceDto)
    }

    async addPersonToAudience(audienceId: string, personId: string) {
        return await this.rep.addPersonToAudience(audienceId, personId)
    }

    async removeFromAudience(audienceId: string, personId: string) {
        return await this.rep.removeFromAudience(audienceId, personId)
    }
}
